<div id="step4_chooseReactions" class="collapse" style="clear: both; display: none;">
		
	<!-- Title -->
	<h1 style="color:#f57300; font-size: 50px">
		<i class="fa fa-flask" aria-hidden="true"></i>
		STEP 4: CREATE REACTION(S)
	</h1>
	
	<!-- Instructions -->
	<p style="color: #ffffff; font-size: 18px">
		Select what will occur when this rule is triggered. Pick as many as you want.
	</p>
	
	<!-- Current Actions/Reactions -->
	<div *ngIf="mRule.actions != null && mRule.actions.length > 0" class="collapse" style="clear: both; display: block; margin: 20px;">
		<app-rule-editor-action-editor *ngFor="let action of mRule.actions; let i = index;"
			[mUniqueIndex]="i"
			[mAction]="action"
			[mEvent]="this.mRule.event"
			(removeAction)="removeAction($event)"
			>
		</app-rule-editor-action-editor>
	</div>
	
	<!-- Search -->
	<div class="input-group" style="padding-bottom:20px; max-width:100%">
		<input [(ngModel)]="mActionsSearchValue" type="text" class="form-control input-lg" placeholder="Search For a Reaction..." (keyup)="refreshActionsCarouselPages()">
		<div class="input-group-btn">
			<button (click)="refreshActionsCarouselPages()" type="button" style="height: 46px" class="btn btn-ef btn-lg" tabindex="-1">
				<span class="glyphicon glyphicon-search"></span>
			</button>
		</div>
	</div>
		
	<!-- Carousel -->
	<div id="actionCarousel" class="carousel slide">
		
		<!-- Carousel Items/Pages -->
		<div class="carousel-inner">
			<ng-container *ngFor="let page of mActionCarouselPages">
				<div [class.active]="page == mActionCarouselPages[0]" class="item">
					<div class="row">
						<ng-container *ngFor="let action of page.mActions">
							<div>
								<div class="col-sm-3">
									<div (click)="actionSelected(action)" class="panel panel-drk-ornge edgefinityButton">
										<div class="panel-body" style="height: 190px; overflow: hidden; max-height: 100%">
											<div class="pull-right">
												<button type="button" class="btn btn-ef btn-xs" data-toggle="collapse" data-target="#">
													<i class="fa fa-plus" aria-hidden="true"></i>
												</button>
											</div>
											<div class="panel-body" style="min-height: 190px; max-height: 100%">
												<i class="fa fa-4x {{getGlyphForAction(action)}}" aria-hidden="true" style="color: #f57300"></i>
												<h3 style="overflow: hidden">{{action.name}}</h3>
												<h4 style="overflow: hidden">{{action.description}}</h4>
											</div>
										</div>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
	
	<!-- Carousel Navigation Links -->
	<ol id="eventCarouselPaging" class="eventCarousel carousel-linked-nav pagination" style="margin-top: 10px; margin-bottom: 20px">
			<li *ngFor="let page of mActionCarouselPages" [class.active]="mActionsPageNumber == page.mId" (click)="setActionsPageNumber(page.mId)" data-target="#actionCarousel" [attr.data-slide-to]="page.mId - 1">
				<a>{{page.mId}}</a>
			<li>
	</ol>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>